const LOGO_URL = 'https://customer-assets.emergentagent.com/job_keyless-vending-1/artifacts/9rpednbz_keyless-vending-logo.png';

const NAV_LINKS = [
  { label: 'What We Do', href: '#what-we-do' },
  { label: 'Machines', href: '#machines' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Service Area', href: '#service-area' },
  { label: 'Contact', href: '#contact' },
];

export const Footer = () => {
  const handleNavClick = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-kv-black py-12 sm:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col items-center">
        {/* Logo */}
        <img
          src={LOGO_URL}
          alt="Keyless Vending"
          className="h-14 sm:h-16 w-auto object-contain mb-8"
        />

        {/* Nav Links */}
        <div className="flex flex-wrap justify-center gap-6 mb-8">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-sm text-white/50 hover:text-white/80 transition-colors font-sans"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Divider */}
        <div className="w-full max-w-xs h-px bg-white/10 mb-6" />

        {/* Copyright */}
        <p className="text-xs text-white/30 font-sans">
          &copy; 2025 Keyless Vending &middot; San Antonio, TX
        </p>
      </div>
    </footer>
  );
};
